import { Link } from '@tanstack/react-router';
import { Edit3 } from 'lucide-react';
import { DashboardTableRowActionItem, DashboardTableRowActions } from '@shigo-ui/dashboard-ui';

import { dashboardT } from '../../../../lib/messages';

export function TargetingBuilderActions({ id, name }: { id: string; name: string }) {
  return (
    <DashboardTableRowActions label={dashboardT('targetingBuilder.actionsFor', { name })}>
      <DashboardTableRowActionItem asChild>
        <Link to="/targeting/$targetingId/edit" params={{ targetingId: id }}>
          <Edit3 className="h-4 w-4" aria-hidden="true" />
          {dashboardT('targetingBuilder.edit')}
        </Link>
      </DashboardTableRowActionItem>
    </DashboardTableRowActions>
  );
}
